import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Thumbnail from 'components/Thumbnail';

import { FilePropType } from 'propTypes/common';

import styles from './styles.module.scss';

const ExhibitsPreview = ({ file, index, isActive, onClick }) => (
	<button
		className={cx(
			styles.ExhibitsPreview,
			isActive && styles.ExhibitsPreview_active
		)}
		type="button"
		data-index={index}
		onClick={onClick}
	>
		<Thumbnail file={file} keepRatio params={{ width: 203, height: 203 }} />
	</button>
);

ExhibitsPreview.propTypes = {
	file: FilePropType.isRequired,
	index: PropTypes.number.isRequired,
	isActive: PropTypes.bool,
	onClick: PropTypes.func.isRequired
};

export default ExhibitsPreview;
